// 粉色主题配置 - 浪漫、温柔、恋爱氛围（方案一：浪漫玫瑰粉）
export const blueTheme = {
  colors: {
    'psychology-primary': '#FF69B4',      // Hot Pink - 热情粉红，充满活力
    'psychology-secondary': '#FFB6C1',    // Light Pink - 浅粉红，柔和甜美
    'psychology-accent': '#FFC0CB',       // Pink - 粉红，轻盈梦幻
    'psychology-calm': '#FFF0F5',         // Lavender Blush - 极浅粉，温馨背景
    'psychology-warm': '#FFE4E1',         // Misty Rose - 浅粉，温暖背景
    'psychology-success': '#10b981',      // 深绿色 - 成功、积极（保持）
    'psychology-info': '#FF69B4',         // Hot Pink - 信息状态（与主色一致）
    'psychology-warning': '#f59e0b',      // 警告橙 - 提醒色（保持）
  },
  name: 'blue',
  description: '浪漫玫瑰粉主题 - 热情、活力、充满恋爱气息'
}
